import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,
    organizations: Object
  },
  data: function data() {
    return {
      form: {
        search: this.filters.search,
        type: this.filters.type
      }
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/organizations', pickBy(this.form), {
          preserveState: true
        });
      }, 150)
    }
  },
  methods: {
    reset: function reset() {
      this.form = mapValues(this.form, function () {
        return null;
      });
    },
    getTenantStatusClass: function getTenantStatusClass(status) {
      return {
        'pill active': status == 'active' || status == 'trial' || status == 'trialWithoutCard',
        'pill pause': status == 'defunct',
        'pill suspend': status == 'suspend' || status == 'grace',
        'pill pending': status == 'new',
        'pill free': status == 'free'
      };
    }
  }
};